<style scoped>
.property-list-title {
  font-size: large;
}
</style>

<template>
  <b-modal
    size="lg"
    :id="id"
    header-class="anchor-modal"
    footer-bg-variant="light"
    scrollable
    centered
    ok-only
    hide-footer
    ref="searchModal"
    title="Search Properties"
    @keyup.enter.native="search"
  >
    <search-property-form
      id="search-property-form"
      :selected-apn-list="selectedApnList"
      @properties-found="(properties) => $emit('properties-found', properties)"
      @property-clicked="(property, index) => $emit('property-clicked', property, index)"
      @close-search="hideModal"
    />
  </b-modal>
</template>


<script>

import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

import SearchPropertyForm from '@/components/utils/properties/SearchPropertyForm';


library.add(faSearch, faExclamationTriangle);

export default {
  components: {
    SearchPropertyForm,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    selectedApnList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      searched: false,
    };
  },
  methods: {
    hideModal() {
      return this.$refs.searchModal.hide();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/properties/SearchPropertyModal.vue